import { CanDeactivateFn } from '@angular/router';

export interface AccountEditorPage {
  canLeave(): boolean | Promise<boolean>;
}

export const unsavedAccountGuard: CanDeactivateFn<AccountEditorPage> = component => component.canLeave();
